module.exports = __webpack_public_path__ + "ColorMatchTitle.png";